let base = window.location.origin;

/**
 * Dedicated nodes are deployed from the same build with the same environment,
 * so the origin is the only thing that tells them apart. Add a node by adding
 * its origin here.
 */
const NODES = {
	'https://v2system.jeevanjyoti.edu.np': {
		transit: 'https://transit-j.eacademynepal.com',
		billing: 'https://billingj-v2.eacademynepal.com',
		report: 'https://reporting-j.eacademynepal.com',
	},
	'https://v2system-invoice.jeevanjyoti.edu.np': {
		transit: 'https://transit-ji.eacademynepal.com',
		billing: 'https://billing-ji-v2.eacademynepal.com',
		report: 'https://reporting-ji.eacademynepal.com',
	},
};

const node = NODES[base] || null;
const isV2Node = Boolean(node) || process.env.VUE_APP_V2;

/**
 * Schools still reaching the pre IRD system are shown a notice pointing at the
 * IRD verified one that replaced it.
 */
const SUPERSEDED_SYSTEMS = {
	'https://system.jeevanjyoti.edu.np': 'https://v2system.jeevanjyoti.edu.np',
};

let uri = 'https://transit.eacademynepal.com';
if (base === 'http://localhost:8080' || base === 'http://localhost:8081')
	uri = 'http://transit.test';
else if (base === 'https://eacademy.sahakaryatech.com')
	uri = 'https://transit.sahakaryatech.com';
else if (isV2Node)
	uri = (node && node.transit) || 'https://transit-j.eacademynepal.com';

const config = {
	APP_KEY: '8c2f3fb78fc7e96854a21d0cc71d085b183d4886ff24ff82696c14049f317701',
	SYSTEM_HOST: base,
	BASE_URL: process.env.VUE_APP_CONNECTION === 'QA' ? (process.env.SERVER_URI || 'https://transit.sahakaryatech.com') : uri,
	APP_ENV: process.env.VUE_APP_CONNECTION//replace later with .env
};

if (process.env.VUE_APP_CONNECTION !== 'QA' && process.env.VUE_APP_CONNECTION !== 'LIVE' && process.env.VUE_APP_CONNECTION !== 'DEV') {
	config.BASE_URL = 'https://transit.eacademynepal.com';
}

if (process.env.VUE_APP_TIER_URL) {
	config.BASE_URL = process.env.VUE_APP_TIER_URL;
}

config.V2_SERVICES = {
	BILLING: process.env.VUE_APP_BILLING_V2_URL || (node && node.billing) || (isV2Node ? "https://billingj-v2.eacademynepal.com" : "https://billing-v2.eacademynepal.com"),
	ACADEMIC: "https://academic-v2.eacademynepal.com",
	TRANSIT: "https://transit-v2.eacademynepal.com",
	ACCOUNT: "https://account-v2.eacademynepal.com",
	TRANSPORT: "https://transport-v2.eacademynepal.com",
	REPORT: "https://report-v2.eacademynepal.com",
	LIBRARY: "https://library-v2.eacademynepal.com",
	EVENT: "https://event-v2.eacademynepal.com",
}

config.NODE = node;
config.SUPERSEDED_BY = SUPERSEDED_SYSTEMS[base] || null;
config.isV2Mode = isV2Node;

config.rest = {
	OK: 200,
	CREATED: 201,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	UNACCEPTABLE: 406
};

export default config